<template>
  <div>
    <section>
      <div class="page-title">Editors In Chief</div>
      <div class="authors-list">
        <author v-for="member in editorsInChief" :key="member.id" v-bind:author="member">
          <router-link slot="details-link" :to="{ name: 'editorialBoardMemberDetail', params: { id: member.id }}">Read More</router-link>
        </author>
      </div>
    </section>
    <section>
      <div class="page-title">Editorial Board Members</div>
      <div class="authors-list">
        <author v-for="member in editorialBoardMembers" :key="member.id" v-bind:author="member">
          <router-link slot="details-link" :to="{ name: 'editorialBoardMemberDetail', params: { id: member.id }}">Read More</router-link>
        </author>
      </div>
    </section>
  </div>
</template>

<script>
  import Author from '@/components/shared/AuthorComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    components: {
      Author
    },
    mixins: [UtilityMixin],
    name: 'editorial-board-members',
    data () {
      return {
        editorsInChief: [],
        editorialBoardMembers: []
      }
    },
    created () {
      // ToDo: replace mock.json with data from services (authors list)
      this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
        this.editorsInChief = response.body.editorsInChief
        this.editorialBoardMembers = response.body.editorialBoardMembers
      }, function () {
      })
    }
  }
</script>


<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// EditorialBoardMembersPage.vue?ede5bb2c